import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiRequest } from "@/lib/api";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";

export default function SifreSifirla() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);
  const { settings } = useSiteSettingsContext();
  const name = settings.siteName || "Dersdinle";

  const [institution] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('hesap') === 'kurum');
  const account_type = institution?'institution':'user';
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token') || '');
 useEffect(() => {
  window.history.replaceState(null,'',window.location.pathname);
  let cancelled=false;
  apiRequest<{valid:boolean}>('/password-recovery.php',{method:'POST',body:{action:'validate',token,account_type}})
   .then(data=>{if(!cancelled)setValid(data.valid);})
   .catch(()=>{if(!cancelled)setValid(false);})
   .finally(()=>{if(!cancelled)setChecking(false);});
  return ()=>{cancelled=true;};
 },[token,account_type]);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus(null);

    const form = e.currentTarget;
    const fd = new FormData(form);
    const password = String(fd.get("password") || "");
    const confirm = String(fd.get("confirm") || "");

    if (!password) return;
    if (password.length < 10 || !/\p{L}/u.test(password) || !/[0-9]/.test(password)) {
      setStatus("Şifreniz en az 10 karakter, harf ve rakam içermeli.");
      return;
    }
    if (password !== confirm) {
      setStatus("Şifreler birbiriyle eşleşmiyor. Lütfen kontrol edin.");
      return;
    }

    setLoading(true);
    try {
      await apiRequest('/password-recovery.php',{method:'POST',body:{action:'reset',token,password,account_type}});
      navigate((institution?'/kurum/giris':'/giris')+'?parola=yenilendi',{replace:true});
    } catch {
      setStatus("Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <main className="flex-1 flex items-center justify-center px-4 py-10 md:py-16">
        <div className="w-full max-w-md">
          <Link
            to="/"
            className="flex items-center justify-center mb-8"
            aria-label={`${name} ana sayfa`}
          >
            <img
              src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/701ba01ffa472e24f05c5cced92a417f.png"
              alt={name}
              className="h-10 w-auto object-contain"
            />
          </Link>

          <div className="rounded-lg border border-background-200 bg-background-50 p-7 md:p-8">
            <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              Yeni şifreni belirle
            </h1>
            <p className="mt-1.5 text-sm text-foreground-600">
              Hesabın için güçlü ve unutmayacağın yeni bir şifre oluştur.
            </p>

            {checking ? (
              <div className="mt-6 flex items-center justify-center gap-2 text-sm text-foreground-500 py-8">
                <i className="ri-loader-4-line animate-spin" aria-hidden="true"></i>
                Kontrol ediliyor...
              </div>
            ) : valid ? (
              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <div>
                  <label
                    htmlFor="sifre-sifirla-yeni"
                    className="block text-sm font-medium text-foreground-800"
                  >
                    Yeni şifre
                  </label>
                  <input
                    id="sifre-sifirla-yeni"
                    name="password"
                    type="password"
                    required
                    autoComplete="new-password"
                    placeholder="En az 10 karakter, harf ve rakam"
                    className="mt-1.5 w-full h-11 px-3.5 rounded-md border border-background-200 bg-background-100/60 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none transition-colors"
                  />
                </div>

                <div>
                  <label
                    htmlFor="sifre-sifirla-tekrar"
                    className="block text-sm font-medium text-foreground-800"
                  >
                    Yeni şifre (tekrar)
                  </label>
                  <input
                    id="sifre-sifirla-tekrar"
                    name="confirm"
                    type="password"
                    required
                    autoComplete="new-password"
                    placeholder="Şifreni tekrar yaz"
                    className="mt-1.5 w-full h-11 px-3.5 rounded-md border border-background-200 bg-background-100/60 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none transition-colors"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full h-11 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
                </button>
              </form>
            ) : (
              <div className="mt-6 rounded-md bg-background-100 p-4 text-center">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Bu bağlantı geçersiz veya süresi dolmuş. Yeni bir sıfırlama bağlantısı
                  istemek için aşağıdaki adımdan devam edin.
                </p>
                <Link
                  to={institution?"/sifremi-unuttum?hesap=kurum":"/sifremi-unuttum"}
                  className="mt-4 inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap"
                >
                  Yeni bağlantı iste
                </Link>
              </div>
            )}

            {status && (
              <p className="mt-4 text-sm text-foreground-600 bg-background-100 rounded-md p-3 leading-relaxed">
                {status}
              </p>
            )}

            <p className="mt-6 text-sm text-center text-foreground-600">
              <Link to={institution?"/kurum/giris":"/giris"} className="text-primary-700 font-semibold hover:text-primary-800">
                Giriş Yap
              </Link>
            </p>
          </div>

          <p className="mt-6 text-center text-xs text-foreground-500">
            <Link to="/" className="hover:text-foreground-700 transition-colors">
              ← Ana sayfaya dön
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}